import { ICommunityBlogItem } from 'Frontend/scripts/models/communityBlog.model'
import { FunctionComponent, useState } from 'react'
import { useScroll } from 'Frontend/hooks/useScroll'
import { CommentCollectionItem } from 'Frontend/scripts/models/communityNews.model'
import * as commentsService from 'Frontend/scripts/services/comments.services'
import { Col, Row } from 'react-bootstrap'
import Comments from 'Features/Components/Comments/Comments'
import { convertDateAndTime } from 'Frontend/scripts/convertDates'

interface BlogItemProps {
  blogItem: ICommunityBlogItem
  commentCollection?: CommentCollectionItem
}

const CommunityBlogItem: FunctionComponent<BlogItemProps> = ({ blogItem, commentCollection }) => {
  const { scrollToElement } = useScroll()
  const [comments, setComments] = useState<CommentCollectionItem>(commentCollection as CommentCollectionItem)
  const { heading, sortDate, preamble, caseImageUrl, url, contentId } = blogItem

  const getComments = () => {
    commentsService.getComments(contentId).then((comments) => {
      setComments(comments)
      scrollToElement(`${contentId}-comments`)
    })
  }

  const createMarkup = (preamble: string) => {
    return { __html: preamble }
  }

  return (
    <article className="blog-list__item position-relative">
      <h3 className="blog-list__item-title">
        <a href={url} className={`blog-list__item-link ${!commentCollection && 'stretched-link'}`}>
          {heading}
        </a>
      </h3>
      <div className="blog-list__date">
        <span className="me-2">{convertDateAndTime(sortDate)}</span> Blogginlägg
      </div>
      <Row>
        <Col md={caseImageUrl ? 8 : 12}>
          {preamble && (
            <div
              className="blog-list__item-text"
              id={`${contentId}-comments`}
              dangerouslySetInnerHTML={createMarkup(preamble)}
            ></div>
          )}
        </Col>
        {caseImageUrl && (
          <Col>
            <img src={caseImageUrl} alt="" />
          </Col>
        )}
      </Row>
      <Comments
        contentId={contentId}
        {...(comments || { comments: [], totalCount: 0 })}
        onPostAdded={() => getComments()}
        onPostDeleted={() => getComments()}
      />
    </article>
  )
}

export default CommunityBlogItem
